import styled from 'styled-components';

export const NavigationControlContainerStyled = styled.div<{ position: string }>`
  position: absolute;
  ${({ position }) => {
    switch (position) {
      case 'top-left':
        return 'top: 10px; left: 10px;';
      case 'top-right':
        return 'top: 10px; right: 10px;';
      case 'bottom-left':
        return 'bottom: 10px; left: 10px;';
      case 'bottom-right':
        return 'bottom: 10px; right: 10px;';
      default:
        return 'top: 10px; right: 10px;';
    }
  }}
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
`;

export const ButtonGroupStyled = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.uiColors.boxBgColor01};
  border-radius: 4px;
  overflow: hidden;
`;

export const ControlButtonStyled = styled.button`
  font-size: 12px;
  width: 24px;
  height: 24px;
  border: none;
  background-color: ${props => props.theme.uiColors.boxBgColor01};
  color: ${props => props.theme.uiColors.multiflightMapTopBarCountTextColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: ${props => props.theme.uiColors.boxBgColor02};
  }
`;
